export const DOMAIN = 'dsw.orion.fi';
export const HEALTH_CHECK_RETRY_TIMEOUT = 5000;
